// extracted by mini-css-extract-plugin
module.exports = {"award":"_2TgRSK4E","container":"_32LvxCAV","marginBottom":"_184uzQjN","showMoreIcon":"_3MmEtL95"};
    if(module.hot) {
      // 1754514963249
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  